import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

interface RegenerateCarrierCodeRequest {
  carrierId: number
}

export const regenerateCarrierCode = async (data: RegenerateCarrierCodeRequest): Promise<void> => {
  await authAPI.post(`/carrier/${data.carrierId}/regenerate-code`)
}

export const useRegenerateCarrierCode = () => {
  return useMutation({
    mutationFn: regenerateCarrierCode,
  })
}
